import L from "leaflet";

import { TILE_REFERRER_POLICY } from "components/maps/tileLayerDefaults";

// Fonte única da camada base do OpenStreetMap.
//
// A política de uso de tiles do OSM (https://operations.osmfoundation.org/policies/tiles/)
// exige:
//  - o host oficial `tile.openstreetmap.org`. Os hosts com sharding
//    (a/b/c.tile.openstreetmap.org) são não oficiais e "podem ser retirados sem
//    aviso" — usá-los é motivo de bloqueio, que chega ao usuário como um tile
//    com o texto "Access blocked" no lugar do mapa;
//  - atribuição visível no mapa. Suprimi-la também é motivo de bloqueio;
//  - um Referer válido nas requisições, e proibe explicitamente removê-lo em
//    tráfego web.
export const OSM_TILE_URL = "https://tile.openstreetmap.org/{z}/{x}/{y}.png";

export const OSM_ATTRIBUTION =
  '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors';

// Zoom máximo que o OSM renderiza. Acima disso o Leaflet reescala o tile do
// zoom 19 em vez de pedir ao servidor tiles que não existem.
export const OSM_MAX_NATIVE_ZOOM = 19;

// Mantido como reexport: a policy vale para qualquer provedor de tile.
export const OSM_REFERRER_POLICY = TILE_REFERRER_POLICY;

export function createOsmTileLayer(options = {}) {
  return L.tileLayer(OSM_TILE_URL, {
    attribution: OSM_ATTRIBUTION,
    maxNativeZoom: OSM_MAX_NATIVE_ZOOM,
    referrerPolicy: OSM_REFERRER_POLICY,
    ...options
  });
}
